import { Box } from '@mui/material';
import React from 'react';
import Logo from '../../Images/logo_main_black.webp';

/**
 * Inline page loader — shows DCC logo within the content area.
 * Used for Suspense fallbacks and initial page loads.
 * Non-blocking — sits inside the page layout, doesn't cover sidebar/nav.
 */
const Loader = ({ height, ...props }: { height?: string }) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="column"
    height={height}
    justifyContent="center"
    gap={2}
    {...props}
  >
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          position: 'absolute',
          width: 80,
          height: 80,
          border: '3px solid #e8e8e8',
          borderTop: '3px solid #c9a84c',
          borderRadius: '50%',
          animation: 'ldspin 1.2s linear infinite',
        }}
      />
      <img
        src={Logo}
        alt=""
        style={{ width: 44, height: 'auto', animation: 'ldfade 1.8s ease-in-out infinite' }}
      />
    </Box>
    <Box textAlign="center">
      <Box
        sx={{
          color: '#1a3353',
          fontWeight: 700,
          letterSpacing: 1.5,
          fontSize: 10,
          textTransform: 'uppercase',
        }}
      >
        Durham Convention Centre
      </Box>
      <Box sx={{ mt: 0.8, display: 'flex', justifyContent: 'center', gap: '3px' }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 4,
              height: 4,
              borderRadius: '50%',
              bgcolor: '#c9a84c',
              animation: `lddot 1.2s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
      </Box>
    </Box>
    <style>
      {`
        @keyframes ldspin { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
        @keyframes ldfade { 0%,100%{opacity:1} 50%{opacity:0.5} }
        @keyframes lddot { 0%,80%,100%{transform:scale(0.6);opacity:0.4} 40%{transform:scale(1);opacity:1} }
      `}
    </style>
  </Box>
);

Loader.defaultProps = {
  height: '100vh',
};

export default Loader;
